import { renderSVG } from "uqr";

// Rendered locally: the URI carries the TOTP secret and must never be sent to a QR service.
export function totpQrDataUri(otpauthUri: string): string | undefined {
  if (!/^otpauth:\/\/totp\/[^\s]+\?(?:[^\s]*&)?secret=[A-Z2-7]+/i.test(otpauthUri)) return undefined;
  const svg = renderSVG(otpauthUri, { ecc: "M", border: 4 });
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
